const environment = process.env.REACT_APP_ENVIRONMENT
const BASE_URL =
  environment === 'production'
    ? process.env.REACT_APP_BASEURL
    : process.env.REACT_APP_BASEURL_DEV

export const URLs = {
  BASE_URL,
}
